const Resources = {

    rest_api: [
        {
            api: 'instant_inspections',
        },
        {
            api: 'template_inspections',
        },
        // {
        //     api: 'assignment_inspections',
        // },
    ],

    table_headers: [
        { 
          text:     'Title',
          align:    'start',
          value:    'title',
          type:     'link',
        },
        {
            text:   'Inspection Type',
            value:  'inspection_type_name'
        },
        {
            text:   'Supervisor',
            value:  'associate'
        },
        { 
            text:   'Inspection Template',
            value:  'inspection_template_name'
        },
        {
            text:   'Room Types',
            value:  'room_types'
        },
        {
            text:   'Associate(s)',
            value:  'all_associates'
        },
        {
            text:   'Rooms Assigned',
            value:  'total_rooms'
        },
        
        {
            text:   'Date',
            value:  'format_date',
        },
        {
            text:   'Score',
            value:  'score',
        },
        {
            text:   'Status',
            value:  'completed_date',
            type:   'boolean_complete',
        }
    ],

    table_headers2: [
        { 
          text:     'Title',
          align:    'start',
          value:    'title',
          type:     'link',
        },
        {
            text:   'Supervisor',
            value:  'associate'
        },
        { 
            text:   'Inspection Template',
            value:  'inspection_template_name'
        },
        {
            text:   'Room Type',
            value:  'room_type_name'
        },
        {
            text:   'Associate(s)',
            value:  'all_associates'
        },
        {
            text:   'Date',
            value:  'format_date'
        },
        {
            text:   'Rooms Assigned',
            value:  'total_rooms'
        },
        {
            text:   'Status',
            value:  'status',
            type:   'boolean_complete',
        }
    ],
    
    table_headers3: [
        { 
          text:     'Title',
          align:    'start',
          value:    'title',
        //   type:     'link',
        },
        {
            text:   'Supervisor',
            value:  'associate'
        },
        {
            text:   'Date',
            value:  'date'
        },
        {
            text:   'Rooms Assigned',
            value:  'rooms_counter'
        },
        {
            text:   'Daily Assignments ',
            value:  'daily_assignments_counter'
        }
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'QC',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Inspections',
            href:   '/qc-inspection',
            arrow:  "",
        },
    ],

    add_btn: [
        {
            name: 'Add Instant Inspection',
            tag_name: 'static-inspection'
        },
        {
            name: 'New Multiple Room Inspection',
            tag_name: 'static-template',
            ref_view: 'qc-template-inspections',
            // event: true,
        },
        // {
        //     name: 'Add Room - Assignment Inspection',
        //     tag_name: 'static-plus-ext'
        // },
    ],

    tabs:[
        {
            id: 1,
            name: 'Instant inspections',
            href_child_tab: '#instant',
            href_child_lists:[
                {
                    href:   '#instant-listation',
                    icon:   'fa fa-list',
                },
                {
                    href:   '#instant-cards-listation',
                    icon:   'fa fa-th-large',
                }
            ]
        },
        {
            id: 0,
            name: 'Template inspections',
            href_child_tab: '#template',
            href_child_lists:[
                {
                    href:   '#template-listation',
                    icon:   'fa fa-list',
                },
                {
                    href:   '#template-cards-listation',
                    icon:   'fa fa-th-large',
                }
            ]
        },
        // {
        //     name: 'Room - Assignment inspections',
        //     href_child_tab: '#assignment',
        //     href_child_lists:[
        //         {
        //             href:   '#assignment-listation',
        //             icon:   'fa fa-list',
        //         },
        //         {
        //             href:   '#assignment-cards-listation',
        //             icon:   'fa fa-th-large',
        //         }
        //     ]
        // },
    ],

    shift_options: [
        {
            id:     0,
            name:   'All'
        },
        {
            id:     1,
            name:   'Day'
        },
        {
            id:     2,
            name:   'Evening'
        },
        {
            id:     3,
            name:   'Night'
        },
    ],

    helps: [
        {
            label: '¿How to create and complete an Instant Inspection?', 
            instruction: `https://scribehow.com/embed/How_To_Create_and_Complete_An_Instant_Inspection__1hHJEoOtRzqAXEZqYKX9rQ?as=scrollable`
        },

        {
            label: '¿How to create an Instant Inspection on the App?', 
            instruction: `https://scribehow.com/embed/Create_an_Instant_Inspection_on_the_App__IsDdclP4RkuC9wxNY7kpIw?as=scrollable`
        },
    ]

}

export default Resources;